import { Divider, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import classes from "./CustomMenuItem.module.css";

const CustomMenuItem = (props) => {
  const textClass= props.hasUtronColor ? `${classes.text} ${classes.deleteText}`: `${classes.text}`;

  const onClick = (event) => {
    props.handleClick(props.data);

    if (!props?.keepOpen) {
      props.closeMenu(false);
    }
  }

  return (
    <div className={classes.customMenuItem}>
      <MenuItem className={props.disabled ? [classes.menuItem, classes.disable].join(' ') : classes.menuItem} onClick={onClick}>
        <ListItemIcon className={classes.icon}>
          <img src={props.icon} fontSize="small" />
        </ListItemIcon>
        <ListItemText className={textClass}>{props.name}</ListItemText>
      </MenuItem>
      {props.hasDivider && <Divider variant="middle" />}
    </div>
  );
};

export default CustomMenuItem;
